import { createRouter, createWebHistory } from "vue-router";
import BlogList from "@/views/BlogList.vue";
import NotFound from "@/views/NotFound.vue";
import BlogPost from "@/views/BlogPost.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: BlogList,
    meta: { title: "Blog | KillAllChickens" },
  },
  {
    path: "/post/:id",
    name: "BlogPost",
    component: BlogPost,
    meta: { title: "Post | KillAllChickens" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: { title: "Page Not Found | KillAllChickens" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
